export default "__VITE_ASSET__2eHuZYXv__"